import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { BroadcastSendingCompletePayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.broadcastSendingComplete,
  (text) => {
    const payload: BroadcastSendingCompletePayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    messagingServiceStore.handleBroadcastSendingCompleteEvent(payload)
  },
)
